<template>
  <div class="container-fluid mt-2">
    <b-tabs content-class="mt-3">
      <b-tab title="Stammdaten">
        <h1>Kundendaten</h1>
        <br/>
        <div class="row">
          <div class="col-md">
            <table class="table">
              <tr>
                <td><b>Kunden-ID:</b></td><td>{{ customer.map_id }}</td>
              </tr>
              <tr>
                <td><b>Name:</b></td><td>{{ customer.title }}</td>
              </tr>
              <tr>
                <td><b>Zusatz:</b></td><td>{{ customer.subtitle }}</td>
              </tr>
              <tr>
                <td><b>Anschrift:</b></td><td>{{ customer.street }}</td>
              </tr>
              <tr>
                <td><b>Stadt:</b></td><td>{{ customer.city }}</td>
              </tr>
              <tr>
                <td><b>PLZ:</b></td><td>{{ customer.pcode }}</td>
              </tr>
              <tr>
                <td><b>Land:</b></td><td>{{ customer.country }}</td>
              </tr>
              <tr>
                <td><b>Vertreter:</b></td><td>{{ customer.handid }}</td>
              </tr>
              <tr>
                <td><b>Kontakt</b></td><td></td>
              </tr>
              <tr>
                <td><b>Telefon:</b></td><td>{{ customer.phone }}</td>
              </tr>
              <tr>
                <td><b>Telefax:</b></td><td>{{ customer.fax }}</td>
              </tr>
              <tr>
                <td><b>E-Mail:</b></td><td><a :href="'mailto:' + customer.email">{{ customer.email }}</a></td>
              </tr>
              <tr>
                <td><b>Web:</b></td><td><a :href="customer.web">{{ customer.web }}</a></td>
              </tr>
              <tr>
                <td><b>Warnung:</b></td><td>{{ customer.warn }}</td>
              </tr>
              <tr>
                <td><b>Gesperrt:</b></td><td><font-awesome-icon v-if="customer.locked" icon="check"/></td>
              </tr>
              <tr>
                <td><b>IM Kontakt:</b></td><td>{{ customer.imcontact }}</td>
              </tr>
              <tr>
                <td><b>Preisliste:</b></td><td>{{ customer.pricelist }}</td>
              </tr>
              <tr><td><b>Zusatzfelder:</b></td><td>
                  <table>
                    <tr v-for="(v,k) in customer.extras" :key="k">
                      <td>{{ k }}</td><td>{{ v }}</td></tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td><b>Sortimente</b></td>
                <td>
                  <ul class="list-group">
                    <li v-for="s in selections" :key="s.map_id" class="list-group-item">{{ s.sort_id }}</li>
                  </ul>
                </td>
              </tr>
            </table>
          </div>
          <div class="col-md" style="padding:10px;">
            <vl-map :load-tiles-while-animating="true" :load-tiles-while-interacting="true"
                         data-projection="EPSG:4326" style="height: 400px">
                <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

                <vl-layer-tile id="osm">
                  <vl-source-osm></vl-source-osm>
                </vl-layer-tile>

                <vl-feature>
                  <vl-geom-point :coordinates="location"></vl-geom-point>
                  <vl-style-box>
                    <vl-style-icon src="/marker.png"/>
                  </vl-style-box>
                </vl-feature>

              </vl-map>
          </div>
        </div>
      </b-tab>
      <b-tab title="Adressen">
        <div class="card" style="width: 20rem;" v-for="c in contacts" :key="c.map_id">
          <div class="card-body">
            <h5 class="card-title">{{ c.name1 }}</h5>
            <h6 class="card-subtitle mb-2 text-muted">{{ c.name2 }}</h6>
            <p class="card-text">{{ c.street }}</p>
            <p class="card-text">{{ c.pcode }}&nbsp;{{ c.city }}</p>
            <p class="card-text">{{ c.country }}</p>
            <p class="card-text">
              <span class="badge badge-info">
                {{ contypes[c.type] }}
              </span>
            </p>
          </div>
        </div>
      </b-tab>
      <b-tab title="Aufträge">
        <OrderList :customer="cid"/>
      </b-tab>
      <b-tab title="CRM">
        <CRMHistoryList :customer="cid"/>
      </b-tab>
      <b-tab title="Zusatzinfos">
        <CustomerExtrasList :customer="cid"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import customers from '@/modules/customers.js'
import OrderList from '@/components/documents/OrderList.vue'
import CustomerExtrasList from '@/components/customer/CustomerExtrasList.vue'
import CRMHistoryList from '@/components/customer/CRMHistoryList.vue'

export default {
  name: 'CustomerView',
  components: {
    OrderList,
    CustomerExtrasList,
    CRMHistoryList
  },
  created: function() {
    var self = this;
    this.cid = this.$route.params.customerid;
    customers.load(this.$route.params.customerid,this,function(data) {
      console.log('got cusotmer');
      self.customer = data.value;
      if (data.location) {
        self.location = [Number(data.location.geolong),Number(data.location.geolat)];
        self.center   = [Number(data.location.geolong),Number(data.location.geolat)];
      }
    });
    customers.listcontacts(this.$route.params.customerid,this,function(data) {
      console.log('got addresses');
      self.contacts = data;
    });
    customers.listselections(this,this.$route.params.customerid,function(data) {
      self.selections = data;
    })
  },
  data() {
    return {
      cid: "",
      contypes: ["Allgemein","Rechnung","Lieferung","Ansprechpartner/bShop"],
      customer: {},
      contacts: [],
      selections: [],
      zoom: 14,
      center: [0, 0],
      rotation: 0,
      location: [0,0],
    }
  }
}
</script>
